import script from "./contactServicePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./contactServicePopup.vue?vue&type=script&setup=true&lang=ts"

import "./contactServicePopup.vue?vue&type=style&index=0&id=07bacbd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07bacbd1"]])

export default __exports__